import React from 'react';
import SectionHeader from './SectionHeader';
import { Reveal } from './ScrollReveal';

export default function Circles() {
  const circles = [
    {
      num: "01",
      title: "GF & C-Level",
      body: "Führungskräfte, die die Einsamkeit an der Spitze kennen. Entscheidungen, die sie mit niemandem intern besprechen können."
    },
    {
      num: "02",
      title: "Gründer & Startups",
      body: "Gründer, die schnell in Führungsrollen gewachsen sind. Hier sitzen Menschen, die dasselbe gerade durchleben."
    },
    {
      num: "03",
      title: "Solopreneure",
      body: "Selbstständige, die alle Entscheidungen allein treffen. Hier sitzen vier Menschen, die das kennen."
    }
  ];

  return (
    <section id="kreis" className="py-32 relative z-10 border-t border-brand-border">
      <div className="max-w-[1100px] mx-auto px-8">
        <SectionHeader 
          num="04" 
          eyebrow="Die drei Kreise" 
          title="3 Gruppen × 4 Mitglieder<br/>=<em class='not-italic italic text-brand-gold'>12 Partner.</em> Nie mehr." 
        />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {circles.map((circle, idx) => (
            <Reveal key={idx} delay={idx * 0.1}>
              <div className="bg-brand-surface border border-brand-border p-10 h-full hover:border-brand-gold/30 transition-colors">
                <div className="text-[0.8rem] font-bold text-brand-gold tracking-[0.2em] uppercase mb-6">Kreis {circle.num}</div>
                <div className="font-serif text-[1.6rem] font-normal text-brand-white mb-4">{circle.title}</div>
                <div className="w-10 h-[1px] bg-brand-gold/30 mb-6"></div>
                <div className="text-[1rem] text-brand-muted leading-relaxed font-light">{circle.body}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}